export const READ_ONLY_MODE = {
    READ_ONLY: "readOnly",
    READ_WRITE: "readWrite",
    AUTO: "auto"
};
